import React from 'react';

import VistaArchivo from '../../Compartidas/VistaArchivo';

import inscripcionesDataHelper from '../../../Helpers/InscripcionData';
import { LICENCIATURAS_INSCRIPCION } from '../../../Helpers/solicitudes';

const ArchivosInscripcion = () => (
    <VistaArchivo
        helper={inscripcionesDataHelper}
        encabezado='Archivo de inscripciones'
        licenciaturas={LICENCIATURAS_INSCRIPCION}
        rutaDetalle='/solicitud-inscripcion-archivado/'
    />
);

export default ArchivosInscripcion;
